import { Pipe, PipeTransform } from '@angular/core';

const unescape = (string) => {
  const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
  const translate = {
    'nbsp': ' ',
    'amp': '&',
    'quot': '\"',
    'lt': '<',
    'gt': '>',
  };
  return string.replace(translate_re, function(match, entity) {
    return translate[entity];
  }).replace(/&#(\d+);/gi, function(match, numStr) {
    const num = parseInt(numStr, 10);
    return String.fromCharCode(num);
  });
}

@Pipe({ name: 'unescape' })
export class UnescapePipe implements PipeTransform  {
  constructor() {}
  transform(value) { return unescape(value); }
}
